import { CognitoUserPool, ICognitoUserPoolData } from 'amazon-cognito-identity-js';
const poolData: ICognitoUserPoolData = {
    UserPoolId: "us-east-1_divUljyGu",
    ClientId: "5in13md7u5jobljaenc3peivie",
};
const userPool = new CognitoUserPool(poolData);
export default userPool;